import * as ACTION from '@Bootstraps/bootstrapActions';
import * as COMPONENT from '@Components';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import JWTDecode from 'jwt-decode';

export default function Component(props) {
  const [showModal, setShowModal] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const { accessToken, cart, clothesDeleteResponse } = useSelector(state => state);
  const { user } = useMemo(() => {
    return JWTDecode(accessToken);
  }, [accessToken]);
  const dispatch = useDispatch();

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary2 text-dark fw-medium px-3',
      cancelButton: 'btn btn-secondary fw-medium me-4 px-3',
    },
    buttonsStyling: false,
  });

  function Delete(id) {
    if (user.role === "admin") {
      swalWithBootstrapButtons
        .fire({
          title: 'Are you sure?',
          background: '#252336',
          color: '#3dcd55',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            dispatch(ACTION.clothesDelete(id));
            dispatch(ACTION.setCart(cart.filter((item) => item !== id)));
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire({
              background: '#252336',
              color: '#3dcd55',
              title: 'Canceled!',
              text: 'Delete cloth is cancel.',
              icon: 'error',
            });
          }
        });
    } else {
      swalWithBootstrapButtons.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Failed!',
        text: 'Unauthorized Access',
        icon: 'error',
      });
    }
  };

  useEffect(() => {
    if (clothesDeleteResponse) {
      swalWithBootstrapButtons
        .fire({
          background: '#252336',
          color: '#3dcd55',
          title: 'Deleted!',
          text: 'Cloth Successfully Deleted',
          icon: 'success',
        })
        .then(() => window.location.reload());
    }
  }, [clothesDeleteResponse, swalWithBootstrapButtons]);

  return (
    <>
      <COMPONENT.ClothesModal
        showModal={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setIsFetching(true);
        }}
        id={props?.id}
        slug={props?.slug}
        fetching={isFetching}
      />
      <div className="d-flex justify-content-center">
        <button
          className="btn btn-dark text-primary2 small shadow-lg rounded-0"
          onClick={() => setShowModal(!showModal)}
        >
          <i className="fa-solid fa-pen"></i>
        </button>
        <button
          className="btn btn-dark text-primary2 small shadow-lg rounded-0"
          onClick={() => Delete(props?.id)}
        >
          <i className="fa-solid fa-trash"></i>
        </button>
      </div>
      <div className="card border-0 shadow-lg p-0">
        <div className="position-relative">
          <div
            className="card-img-top rounded-0"
            style={{
              backgroundImage: `url(${props.image})`,
            }}
          />
          <div
            className={`btn cart-button position-absolute rounded-circle ${
              props.favorite ? 'bg-dark text-primary2' : 'bg-white'
            }`}
            onClick={
              () => props.favorite
                    ? dispatch(ACTION.setCart(cart.filter(item => item._id !== props.id)))
                    : dispatch(ACTION.setCart([ ...cart, { _id: props.id, value: 1 } ]))
            }
          >
            <h5 className="m-0">
              <i className="fa-solid fa-heart"></i>
            </h5>
          </div>
        </div>
        <div className="card-body p-0 text-center">
          <h4 className="card-title fw-bold px-3 mt-4">{props?.title}</h4>
          <p className="card-desc normal fw-medium text-secondary px-3 mt-3 mb-4">
            {props?.desc}
          </p>
          <div className="hr mb-4" />
          <h3 className="fw-bold mb-4">
            {props?.price
              ? props?.price.substr(0, props?.price.length - 3) +
                '.' +
                props?.price.substr(props?.price.length - 3) +
                ',00'
              : '?'}
          </h3>
          <button
            onClick={props?.onClick}
            className="btn btn-dark fw-semibold w-100 p-3 rounded-0"
          >
            BUY NOW
            <span className="text-primary2 ms-2">
              <i className="fa-solid fa-arrow-right"></i>
            </span>
          </button>
        </div>
      </div>
    </>
  );
}
